import { Grid, HStack } from "@biblioteksentralen/react";
import { Publication } from "@libry-content/types";
import { cluster } from "radash";
import { GuessAuthorCoverImage, GuessStateMap } from "./GuessAuthorCoverImage";

export const CoverImageGrid = ({
  publications,
  guessStates,
}: {
  publications?: Publication[];
  guessStates: GuessStateMap[];
}) => {
  // Pair publications in order to make a grid with two or four cover images while making sure the images aren't too big
  const pairedPublications = cluster(publications ?? [], 2);

  return (
    <Grid gridTemplateColumns="repeat(auto-fit, minmax(8rem, 1fr))" width="100%" gap="0.5rem" alignItems="flex-end">
      {pairedPublications.map(([publication1, publication2], idx) => (
        <HStack key={idx}>
          {publication1 && <GuessAuthorCoverImage publication={publication1} guessState={guessStates[2 * idx]} />}
          {publication2 && <GuessAuthorCoverImage publication={publication2} guessState={guessStates[2 * idx + 1]} />}
        </HStack>
      ))}
    </Grid>
  );
};
